/**
 * @Description
 */
export default {
  meta: {
    title: '审批工作台',
    url: '/approveworkbench' // 埋点用，记录所属模块
  },
};

